var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"awards"},[_c('h2',{staticClass:"title AvantGarde"},[_vm._v("OUR ACHIEVEMENTS")]),_c('h3',{staticClass:"title-cn YaSiBlank"}),_c('div',{staticClass:"awards-inner"},[_c('img',{attrs:{"src":require("../../../assets/images/awards.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }